import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useStoreState } from 'easy-peasy';
import { isNaN } from 'lodash';

import { Table } from '../../../components/elements';
// import { getOrders } from './helpers';
import OrderDetails from '../Order/OrderDetails';
import { getOrders } from '../OrderDashboard/helpers';
import useIntersectionObserver from '../../../utils/useIntersectionObserver';

// const getOrders = async () => {};

const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

// const Center2 = styled.div`
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%, -50%);
// `;

const transformOrderData = order => {
  if (
    order &&
    Array.isArray(order.menu_order_listing) &&
    order.menu_order_listing[0]
  ) {
    return order.menu_order_listing[0];
  }
  return null;
};

const transformRefundAmount = val => {
  const num = parseFloat(val);
  return isNaN(num) ? 0 : Math.abs(num);
};

const OrderDetailsTable = ({
  loading,
  userOrderDetailsData,
  loadMoreData,
  setSort,
  sort,
}) => {
  const { userId } = useStoreState(state => state.auth);
  const [orderDataIsLoading, setOrderDataIsLoading] = React.useState(false);
  const [menuOrderId, setMenuOrderId] = React.useState({ id: null });
  const [orderData, setOrderData] = React.useState(null);
  const [
    isActiveOrderDetailsModal,
    setIsActiveOrderDetailsModal,
  ] = React.useState(false);

  const { isIntersecting, ref } = useIntersectionObserver({
    threshold: 0.5,
  });

  useEffect(() => {
    if (isIntersecting) {
      loadMoreData();
    }
  }, [isIntersecting]);

  React.useEffect(() => {
    let ignore = false;
    const fetchData = async () => {
      setOrderDataIsLoading(true);
      const data = await getOrders({
        from: 0,
        size: 50,
        user_id: userId,
        filter: {
          menu_order_filter: {
            menu_order_id: menuOrderId.id,
          },
        },
      });
      const fo = transformOrderData(data);
      if (!ignore && fo) {
        setOrderData(fo);
        setIsActiveOrderDetailsModal(true);
      }
      setOrderDataIsLoading(false);
    };
    if (menuOrderId.id) {
      fetchData();
    }
    return () => {
      console.log(
        'unmounting <or> ignoring previous graphql call to search_menu_order...',
      );
      ignore = true;
    };
  }, [menuOrderId]);
  return (
    <>
      <div style={{ padding: '10px' }}>
        <h1 style={{ display: 'none' }}>Order Details</h1>
        <Table id="order-details-table">
          <thead>
            <tr>
              {[
                'Order Ref',
                'Payment Status',
                'Status',
                'Customer',
                'Email',
                'Phone',
                'Device Info',
                'Place Name',
                'Service',
                'Promo',
                'Amount',
                'Refund',
                'Method',
              ].map(headerCellValue => (
                <th key={headerCellValue} style={{ fontWeight: 700 }}>
                  <div>
                    <span>{headerCellValue}</span>
                  </div>
                </th>
              ))}
              <th>
                <div>
                  <span>
                    <a
                      onClick={() => {
                        setSort(sort === 'DATE_ASC' ? 'DATE_DESC' : 'DATE_ASC');
                      }}
                    >
                      <i
                        className={
                          sort === 'DATE_ASC'
                            ? 'fas fa-sort-amount-down'
                            : 'fas fa-sort-amount-up'
                        }
                      />
                    </a>
                    Date
                  </span>
                </div>
              </th>
            </tr>
          </thead>
          {userOrderDetailsData.length !== 0 && (
            <tbody>
              {userOrderDetailsData.map(detail => (
                <tr
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    setMenuOrderId({ id: detail.menu_order_id });
                  }}
                  key={detail['Order Ref']}
                >
                  <td style={{ color: '#00AEEF', whiteSpace: 'nowrap' }}>
                    {orderDataIsLoading &&
                    detail.menu_order_id === menuOrderId.id
                      ? 'loading Order Details...'
                      : detail['Order Ref']}
                  </td>
                  <td>{detail.payment_status}</td>
                  <td>{detail.Status}</td>
                  <td style={{ color: '#00AEEF', whiteSpace: 'nowrap' }}>
                    {detail.Customer}
                  </td>
                  <td>{detail.Email}</td>
                  <td style={{ whiteSpace: 'nowrap' }}>{detail.Phone}</td>
                  <td>{detail['Device Info']}</td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    {detail['Place Name']}
                  </td>
                  <td>{detail.Service}</td>
                  <td>{detail.Promo}</td>
                  <td>{`$${parseFloat(detail.Amount || 0).toFixed(2)}`}</td>
                  <td>
                    {(() => {
                      const refundsDetails =
                        detail?.Refund && Array.isArray(detail?.Refund)
                          ? detail?.Refund
                          : [];

                      let totalRefund = 0;

                      refundsDetails.forEach(ele => {
                        const ra = transformRefundAmount(ele.refund_amount);
                        totalRefund += ra;
                      });

                      return totalRefund === 0
                        ? '-'
                        : `$${parseFloat(totalRefund).toFixed(2)}`;
                    })()}
                  </td>
                  <td>{detail.Method}</td>
                  <td style={{ whiteSpace: 'nowrap', color: '#00AEEF' }}>
                    {detail.Date}
                  </td>
                </tr>
              ))}
              <div
                ref={ref}
                className="load-more"
                style={{ marginBottom: '1rem' }}
              />
            </tbody>
          )}
        </Table>
        {loading && (
          <Center>
            <span style={{ color: '#00AEEF', fontSize: '24px' }}>
              loading...
            </span>
          </Center>
        )}
      </div>
      {isActiveOrderDetailsModal && (
        <OrderDetails
          dueTimeToBeDisplayedInOrderDetailsModal={null}
          delayTimeToBeDisplayedInOrderDetailsModal={null}
          isActiveOrderDetailsModal={isActiveOrderDetailsModal}
          setIsActiveOrderDetailsModal={setIsActiveOrderDetailsModal}
          orderComponent="OrderDashboard"
          order={orderData}
          refetchData={() => {}}
        />
      )}
    </>
  );
};

export default OrderDetailsTable;
